/* eslint-disable import/prefer-default-export */

// 同一时刻发起的请求不作处理
const buffer: string[] = [];
export function loadScript(url: string) {
  if (buffer.includes(url)) {
    return;
  }
  buffer.push(url);

  return new Promise((rs, rj) => {
    const [head] = document.getElementsByTagName('head');
    const READY_STATE_RE = /^(?:loaded|complete|undefined)$/;
    let script: any = document.createElement('script');
    script.src = url;

    const cb = () => {
      const idx = buffer.indexOf(url);
      if (idx !== -1) {
        buffer.splice(idx, 1);
      }
      head.removeChild(script);
      script.onload = null;
      script.onerror = null;
      script.onreadystatechange = null;
      script = null;
    };
    const onSuccess = () => {
      if (READY_STATE_RE.test(script.readyState)) {
        cb();
        rs();
      }
    };
    const onError = (e: Error) => {
      head.removeChild(head);
      cb();
      rj(e);
    };

    script.onload = onSuccess;
    script.onreadystatechange = onSuccess;
    script.onerror = onError;
    head.appendChild(script);
  });
}
